<template lang="pug">
  b-container
    .d-flex.justify-content-between.mb-4
      h4.mb-0 Resultados
      b-button.b-0(variant="link", size="sn", @click="saveMixpanel('Campaigns Results: Redirect to Campaigns')", :to="{name : 'Campaigns'}")
        chevron-left-icon.icon-md
        span Volver a campañas
    // TOP SECTION
    b-overlay(:show="loading", variant="transparent", spinner-variant="primary" )
      b-card
        b-row
          // CHATBOT SELECTION
          b-col.d-flex.align-items-center.mb-2.mb-md-0(cols="auto")

            b-img.mr-2(src="@/assets/chatbot.png", width="40" )
            .text-left
              div(v-if="singleChatbot") {{chatbotName}}
              b-form-select(v-else, :options="chatbots", v-model="modelId", size="sm" )
              .text-secondary.text-sm Resumen
          // METRIC SECTION
          b-col
            b-form-row.text-center
              b-col.result-section.mb-2.mb-md-0
                send-icon.mr-1.icon-xl.text-primary
                div
                  h5.mb-0 {{sentAtPercent}}%
                  b-badge.text-dark(variant="soft-primary" ) Enviados
              b-col.result-section.mb-2.mb-md-0
                clock-icon.mr-1.icon-xl.text-primary
                div
                  h5.mb-0 {{deliveredAtPercent}}%
                  b-badge.text-dark(variant="soft-primary" ) Entregados
              b-col.result-section.mb-2.mb-md-0
                v-icon.mr-1.icon-xl.text-primary(name="brands/whatsapp")
                div(v-b-tooltip.bottom, title="Solo cuenta a los usuarios que tienen activada 'la opción de leído'")
                  h5.mb-0 {{readAtPercent}}%
                  b-badge.text-dark(variant="soft-primary" ) Leídos
              //b-col.d-flex.align-items-center.justify-content-center(md="2")
                v-icon.mr-1.icon-xl(name="brands/whatsapp")
                div
                  h5.mb-0 90%
                  .text-sm Respuesta
    // CONTENT SECTION
    b-card
      // QUERY
      b-form-row.align-items-center.justify-content-between.mb-3
        //DATE SELECTION
        b-col(cols="auto")
          date-range-picker(v-bind="calendarProps", v-model="dates", :maxDate="$moment().format()", @update="fetchCampaigns")
            template(#input="picker")
              b-input-group(size="sm" )
                b-form-input.bg-white(placeholder="Seleccionar fecha", :value="datesFormat", readonly)
                b-input-group-append
                  b-input-group-text
                    calendar-icon.text-secondary.icon-sm
        // SEARCH INPUT
        b-col.d-flex.align-items-center(md="6", lg="5")
          b-input-group#search-input.mr-2(size="sm")
            b-form-input(placeholder="Buscar reporte", v-model="search", debounce="1000" type="search", @update="fetchCampaigns")
            b-input-group-append
              b-input-group-text
                search-icon.icon-md
          b-button(size="sm", variant="primary", v-b-tooltip, title="Actualizar el estado de progreso de los envíos", :disabled="loadingResults", @click="fetchCampaigns(true)")
            b-spinner(small, v-if="loadingResults" )
            refresh-cw-icon.icon-md(v-else)
      // CAMPAIGNS HEADERS
      b-form-row.mb-3.px-3.d-none.d-md-flex.justify-content-between
        b-col(md="2", v-for="field in fields", :key="field") {{field}}
      // LOADING SPINNER
      .text-center.my-2(v-if="loadingResults")
        b-spinner(variant="primary")
      // EMPTY MESSAGE
      empty-message(v-else-if="!campaigns.length", :message="search.length ? 'No hay coincidencias' : 'No hay resultados aún'" )
      // CAMPAIGNS LIST
      b-card.mb-1(v-for="(item, index) in campaigns", :key="index", no-body)
        b-form-row.py-2.px-3.align-items-center.text-center.text-md-left.text-sm
          b-col(md="2")
            b-link.text-underline(v-if="item.file_url", :href="item.file_url", @click="saveMixpanel('Campaigns Results: Download users file')", v-b-tooltip.bottom="'Descargar archivo de usuarios'") {{item.name}}
            div(v-else) {{item.name}}
          b-col(md="2" )
            div {{item.template_data.template_name}}
            .text-secondary
              calendar-icon.icon-sm.mr-1
              span {{$moment(item.date).format("DD MMMM YYYY HH:mm")}}
          b-col(md="2" )
            span.mr-1.d-md-none Enviados:
            span {{item.sent}}
          b-col(md="2" )
            span.mr-1.d-md-none Entregados:
            span {{item.delivered}}
          b-col(md="2" )
            span.mr-1.d-md-none Leídos:
            span {{item.read}}
          b-col(md="2" )
            b-overlay.d-flex.align-items-center(:show="item.loading", variant="transparent", spinner-variant="primary", spinner-small)
              b-button.b-0(variant="outline-secondary", size="sm", @click="getReport(item)")
                download-icon.icon-sm.mr-1
                span Reporte
              trash-icon.pointer.hover-danger.icon-md.mr-2.text-secondary(@click="confirmDelete(item).then()", v-b-tooltip, title="Eliminar")
      // PAGINATION
      Pagination(:current-page="paginationCurrentPage", :has-next-page="v_paginationHasNextPage", :total-pages="v_paginationTotalPages", :loading="loadingResults", @click="paginationPageChanged($event, 'getCampaigns')")
    // HELPER TO DOWNLOAD REPORTS
    a.d-none#download_link(download, ref="download_link")
</template>

<script>
import Pagination from "@/components/Pagination";
import Select from '@/components/Select'
import Days from "@/data/days";
import Months from "@/data/months";
import { createNamespacedHelpers, mapActions } from 'vuex'
import mixpanel from "@/mixpanel";
import Download from 'downloadjs'

const accountController = createNamespacedHelpers('account')
const broadcastController = createNamespacedHelpers('broadcast')
const platformController = createNamespacedHelpers('platform')

export default {
  name: "CampaignsResults",
  data () {
    return {
      loading: false,
      loadingResults: false,
      modelId: null,
      search: '',
      readAtPercent: 0,
      sentAtPercent: 0,
      deliveredAtPercent: 0,
      fields: [
        'Reporte',
        'Plantilla',
        'Enviados',
        'Entregados',
        'Leídos',
        'Acciones'
      ],
      dates: {
        startDate: null,
        endDate: null,
      },
      calendarProps: {
        linkedCalendars: false,
        showDropdowns: true,
        ranges: false,
        opens: 'right',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        }
      },
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account
    }),
    ...platformController.mapState({
      chatbots: state => state.chatbots.map(el =>{
        el.value = el.model_id
        el.text = el.phone_number ? `${el.name} - ${el.phone_number}` : el.name
        return el
      })
    }),
    ...broadcastController.mapState({
      campaigns: state => state.campaigns
    }),
    singleChatbot () {
      return this.chatbots.length === 1
    },
    chatbotName () {
      const chatbot = this.chatbots.find(el => el.model_id === this.modelId)
      if(!chatbot) return ''
      return chatbot.name
    },
    datesFormat () {
      return this.$moment(this.dates.startDate).format('DD MMM YYYY') + ' - ' + this.$moment(this.dates.endDate).format('DD MMM YYYY')
    },
  },
  methods: {
    ...mapActions([
      'platform/all',
      'platform/get',
      'broadcast/campaigns',
      'broadcast/message_counts',
      'broadcast/campaign_report',
      'broadcast/destroy',
    ]),
    getChatbots () {
      this.loading = true
      this['platform/get']({
        account_id: this.$route.params.account_id,
        platform_id: 'whatsapp_official',
        callback: async (res) => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)

          if(res.resource.length) {
            this.modelId = res.resource[0].model_id
          }
        }
      })
    },
    getCampaigns (refreshing = false) {
      this.loadingResults = true

      if(refreshing) this.getMessageCounts()

      this['broadcast/campaigns']({
        account_id: this.$route.params.account_id,
        refreshing,
        params: {
          status: 'executed',
          model_id: this.modelId,
          name: this.search,
          init_date: this.dates.startDate,
          final_date: this.dates.endDate,
          ...this.paginationParamsObject
        },
        callback: res => {
          this.loadingResults = false
          if (res.error) return this.$message.error(res.error)
          this.parsePaginationDataFromResponse(res)
        }
      })
    },
    fetchCampaigns (refreshing = false){
      this.resetPaginationData()
      this.getCampaigns(refreshing)
    },
    getMessageCounts () {
      this.loading = true
      this['broadcast/message_counts']({
        params: {
          account_id: this.$route.params.account_id,
          status: 'executed',
          model_id: this.modelId,
        },
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          const {readAtPercent = 0, sentAtPercent = 0, deliveredAtPercent = 0} = res.resource
          this.readAtPercent =  readAtPercent
          this.sentAtPercent =  sentAtPercent
          this.deliveredAtPercent =  deliveredAtPercent
        }
      })
    },
    getReport (item) {
      item.loading = true

      this['broadcast/campaign_report']({
        account_id: this.$route.params.account_id,
        campaign_id: item._id,
        callback: res => {
          item.loading = false
          if (res.error) return this.$message.error(res.error)
          if(res.resource && res.resource.url){
            this.downloadFile(res.resource, item.name)
            this.saveMixpanel('Campaigns Results: Download report')
          }
        }
      })
    },
    async downloadFile({url}, name) {
      try {
        $('#download_link').attr({href: url, download: name});
        this.$refs.download_link.click()
      } catch (e) {
        console.log(e)
        this.$message.error("Error descargando reporte, intenta de nuevo")
      }
    },
    async confirmDelete (item) {
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Eliminar reporte ${item.name}?`, {
          title: 'Eliminar reporte',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
        })
        if (response) {
          this.deleteReport(item)
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    deleteReport (item) {
      item.loading = true

      this['broadcast/destroy']({
        campaign_id: item._id,
        callback: res => {
          item.loading = false
          if (res.error) return this.$message.error(res.error)

          this.$message.success('Reporte eliminado')
        }
      })
    },
    saveMixpanel (event) {
      const {email, admin_id, role_id} = this.getCurrentUser()
      mixpanel.track(event, {
        account_id: this.$route.params.account_id,
        unique_id: email,
        admin_id,
        role_id
      });
    }
  },
  mounted () {
    this.dates.startDate = this.$moment().subtract(1, 'w').format();
    this.dates.endDate = this.$moment().format()
    this.getChatbots()
  },
  watch: {
    modelId () {
      this.getMessageCounts()
      this.fetchCampaigns()
    }
  },
  components: {Pagination, 'k-select': Select}
}
</script>

<style lang="scss" scoped>
  .result-section {
    display: flex;
    justify-content: center;
    align-items: center;

    &:not(:last-child) {
      border-right: 1px solid var(--primary);
    }
  }
</style>
